import { createReducer } from 'typesafe-actions';

import { ITemplateState, TTemplateActions, TemplateActionTypes } from '@/store/types/template.types';
import { TemplatesTools } from '@/utils/tools/TemplatesTools';

const initialState: ITemplateState = {
  templateGroups: {},
};

export const templateReducer = createReducer<ITemplateState, TTemplateActions>(initialState)
  .handleType(TemplateActionTypes.SEARCH_TEMPLATES, (state) => ({
    ...state,
    templateGroups: {
      ...state.templateGroups,
      isLoading: true,
      error: undefined,
    },
  }))

  .handleType(TemplateActionTypes.SEARCH_TEMPLATES_FAIL, (state, action) => ({
    ...state,
    templateGroups: {
      ...state.templateGroups,
      isLoading: false,
      error: action.error,
    },
  }))

  .handleType(TemplateActionTypes.SEARCH_TEMPLATES_SUCCESS, (state, action) => {
    const templateGroups = TemplatesTools.buildTemplateGroups(action.templateKeys);

    return {
      ...state,
      templateGroups: {
        ...state.templateGroups,
        state: templateGroups,
        isLoading: false,
        error: undefined,
      },
    };
  })

  .handleType(TemplateActionTypes.SEARCH_TEMPLATE_MODEL, (state, action) => {
    const templateGroups = state.templateGroups.state?.[action.group].map((templateGroup) => {
      if (templateGroup.state?.template.name === action.name) {
        return {
          ...templateGroup,
          isLoading: true,
          error: undefined,
        };
      }

      return templateGroup;
    });

    return {
      ...state,
      templateGroups: {
        ...state.templateGroups,
        state: {
          ...state.templateGroups.state,
          [action.group]: templateGroups || state.templateGroups[action.group],
        },
      },
    };
  })

  .handleType(TemplateActionTypes.SEARCH_TEMPLATE_MODEL_FAIL, (state, action) => {
    const templateGroups = state.templateGroups.state?.[action.group].map((templateGroup) => {
      if (templateGroup.state?.template.name === action.name) {
        return {
          ...templateGroup,
          isLoading: false,
          error: action.error,
        };
      }

      return templateGroup;
    });

    return {
      ...state,
      templateGroups: {
        ...state.templateGroups,
        state: {
          ...state.templateGroups.state,
          [action.group]: templateGroups || state.templateGroups[action.group],
        },
      },
    };
  })

  .handleType(TemplateActionTypes.SEARCH_TEMPLATE_MODEL_SUCCESS, (state, action) => {
    const templateGroups = state.templateGroups.state?.[action.group].map((templateGroup) => {
      if (templateGroup.state?.template.name === action.name) {
        return {
          ...templateGroup,
          state: {
            ...templateGroup.state,
            model: action.model,
          },
          isLoading: false,
          error: undefined,
        };
      }

      return templateGroup;
    });

    return {
      ...state,
      templateGroups: {
        ...state.templateGroups,
        state: {
          ...state.templateGroups.state,
          [action.group]: templateGroups || state.templateGroups[action.group],
        },
      },
    };
  })

  .handleType(TemplateActionTypes.SAVE_TEMPLATE, (state, action) => {
    const templateGroups = state.templateGroups.state?.[action.group].map((templateGroup) => {
      if (templateGroup.state?.template.name === action.name) {
        return {
          ...templateGroup,
          isLoading: true,
        };
      }

      return templateGroup;
    });

    return {
      ...state,
      templateGroups: {
        ...state.templateGroups,
        state: {
          ...state.templateGroups.state,
          [action.group]: templateGroups || state.templateGroups[action.group],
        },
      },
    };
  })

  .handleType(TemplateActionTypes.SAVE_TEMPLATE_FAIL, (state, action) => {
    const templateGroups = state.templateGroups.state?.[action.group].map((templateGroup) => {
      if (templateGroup.state?.template.name === action.name) {
        return {
          ...templateGroup,
          isLoading: false,
          error: action.error,
        };
      }

      return templateGroup;
    });

    return {
      ...state,
      templateGroups: {
        ...state.templateGroups,
        state: {
          ...state.templateGroups.state,
          [action.group]: templateGroups || state.templateGroups[action.group],
        },
      },
    };
  })

  .handleType(TemplateActionTypes.SAVE_TEMPLATE_SUCCESS, (state, action) => {
    const templateGroups = state.templateGroups.state?.[action.group].map((templateGroup) => {
      if (templateGroup.state?.template.name === action.name) {
        return {
          ...templateGroup,
          state: {
            ...templateGroup.state,
            model: action.model,
          },
          isLoading: false,
          error: undefined,
        };
      }

      return templateGroup;
    });

    return {
      ...state,
      templateGroups: {
        ...state.templateGroups,
        state: {
          ...state.templateGroups.state,
          [action.group]: templateGroups || state.templateGroups[action.group],
        },
      },
    };
  });
